<template>
  <section class="section">
    <div class="section-body">
      <div class="card" v-if="!isEdit && mode != 'increase' && mode != 'edit'">
        <div class="card-header">
          <v-icon color="pink">search</v-icon>
          <h4>{{ $t("messages.general.searchShowInfo") }}</h4>
        </div>
        <div class="card-body">
          <v-card width="100%">
            <v-row>
              <v-col
                cols="10"
                style="padding-top: 0; padding-bottom: 0; padding-right: 0;text-align: right;"
              >
                <p style="color: red; margin: 0">*</p>
              </v-col>
              <v-col
                style="padding-top: 0; padding-bottom: 0; padding-right: 5px;"
              >
                <p style="margin: 0">{{ $t("messages.general.reqFields") }}</p>
              </v-col>
            </v-row>
          </v-card>
          <form>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label
                      >{{ $t("messages.general.academicYear") }}
                      <code style="background: none; box-shadow: none;"
                        >*</code
                      ></label
                    >
                  </div>
                  <div class="col no-margin-padding">
                    <AcademicYear
                      :onChanged="onSelYearChanged"
                      :selectedVal="selYear"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label
                      >{{ $t("messages.general.semester") }}
                      <code style="background: none; box-shadow: none;"
                        >*</code
                      ></label
                    >
                  </div>
                  <div class="col no-margin-padding">
                    <Semester
                      :onChanged="onSelSemesterChanged"
                      :selectedVal="selSemester"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label
                      >{{ $t("messages.general.educationLvl") }}
                      <code style="background: none; box-shadow: none;"
                        >*</code
                      ></label
                    >
                  </div>
                  <div class="col no-margin-padding">
                    <Level
                      :onChanged="onSelLvlChanged"
                      :selectedVal="selLvl"
                      :disabled="false"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              class="form-row flex-column justify-content-center align-items-center mt-5"
            >
              <div class="form-group">
                <div class="form-inline">
                  <button
                    type="button"
                    class="btn btn-primary btn-lg"
                    @click="handleSearchConfirmResult()"
                  >
                    {{ $t("messages.general.search") }}</button
                  >&nbsp;&nbsp;&nbsp;
                  <button
                    type="button"
                    class="btn btn-primary btn-lg"
                    @click="increase()"
                  >
                    {{ $t("messages.general.increase") }}</button
                  >&nbsp;&nbsp;&nbsp;
                  <button
                    type="button"
                    class="btn btn-primary btn-lg"
                    @click="handleCopyData()"
                  >
                    {{ $t("messages.general.copy") }}</button
                  >&nbsp;&nbsp;&nbsp;
                  <button
                    type="button"
                    class="btn btn-light btn-lg"
                    @click="handleClearScreen()"
                  >
                    {{ $t("messages.general.clearScreen") }}</button
                  >&nbsp;&nbsp;&nbsp;
                </div>
              </div>
            </div>
          </form>
          <v-card>
            <b-table
              bordered
              hover
              small
              responsive
              caption-top
              class="table table-striped text-center"
              :sort-by.sync="bTable.sortBy"
              :sort-desc.sync="bTable.sortDesc"
              :items="bTable.items"
              :fields="bTable.fields"
              :per-page="perPage"
              :current-page="currentPage"
            >
              <template slot="table-caption">
                <div class="float-left">
                  <b class="mr-2">{{
                    $t("messages.general.table.paginationinfo")
                  }}</b>
                  <b-form-select
                    v-model="perPage"
                    :options="perPageOptions"
                    size="sm"
                    style="width:70px"
                  />
                </div>
                <b-pagination
                  class="float-right"
                  size="sm"
                  :total-rows="bTable.items.length"
                  v-model="currentPage"
                  :per-page="perPage"
                />
                <div
                  v-if="bTable.items.length > 0"
                  class="float-right data-table-page-info"
                >
                  {{
                    Number(
                      currentPage > 1
                        ? (currentPage - 1) * perPage + 1
                        : currentPage
                    ).toLocaleString()
                  }}
                  -
                  {{
                    Number(
                      currentPage * perPage > bTable.items.length
                        ? bTable.items.length
                        : currentPage * perPage
                    ).toLocaleString()
                  }}
                  {{ $t("messages.general.fromRecords") }}
                  {{ Number(bTable.items.length).toLocaleString() }}
                </div>
                <div
                  v-if="bTable.items.length <= 0"
                  class="float-right data-table-page-info"
                >
                  0 - 0
                  {{ $t("messages.general.fromRecords") }}
                  {{ Number(bTable.items.length).toLocaleString() }}
                </div>
              </template>

              <template v-slot:cell(action)="data">
                <v-btn text icon @click="goTo(data.item, data.index, 'edit')">
                  <v-icon>edit</v-icon>
                </v-btn>
                <v-btn text icon @click="handleDeleteGroup(data)">
                  <v-icon> delete</v-icon>
                </v-btn>
              </template>

              <template slot="table-caption">
                <div
                  style="position: absolute; bottom: -65px; width: 100%; height: 65px; padding-top: 10px; border-color: #fff; box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);"
                >
                  <div class="float-left">
                    <b class="mr-2">{{
                      $t("messages.general.table.paginationinfo")
                    }}</b>
                    <b-form-select
                      v-model="perPage"
                      :options="perPageOptions"
                      size="sm"
                      style="width:70px"
                    />
                  </div>
                  <b-pagination
                    class="float-right"
                    size="sm"
                    :total-rows="bTable.items.length"
                    v-model="currentPage"
                    :per-page="perPage"
                    style="padding-top: 10px"
                  />
                  <div
                    v-if="bTable.items.length > 0"
                    class="float-right data-table-page-info"
                    style="padding-top: 14px"
                  >
                    {{
                      Number(
                        currentPage > 1
                          ? (currentPage - 1) * perPage + 1
                          : currentPage
                      ).toLocaleString()
                    }}
                    -
                    {{
                      Number(
                        currentPage * perPage > bTable.items.length
                          ? bTable.items.length
                          : currentPage * perPage
                      ).toLocaleString()
                    }}
                    {{ $t("messages.general.fromRecords") }}
                    {{ Number(bTable.items.length).toLocaleString() }}
                  </div>
                  <div
                    v-if="bTable.items.length <= 0"
                    class="float-right data-table-page-info"
                    style="padding-top: 14px"
                  >
                    0 - 0
                    {{ $t("messages.general.fromRecords") }}
                    {{ Number(bTable.items.length).toLocaleString() }}
                  </div>
                </div>
              </template>
            </b-table>
          </v-card>
        </div>
      </div>
      <div class="card" v-if="!isEdit && mode == 'increase'">
        <div class="card-header">
          <v-icon color="pink">edit</v-icon>
          <h4>{{ $t("messages.general.manageData") }}</h4>
        </div>
        <div class="card-body">
          <v-card width="100%">
            <v-row>
              <v-col
                cols="10"
                style="padding-top: 0; padding-bottom: 0; padding-right: 0;text-align: right;"
              >
                <p style="color: red; margin: 0">*</p>
              </v-col>
              <v-col
                style="padding-top: 0; padding-bottom: 0; padding-right: 5px;"
              >
                <p style="margin: 0">{{ $t("messages.general.reqFields") }}</p>
              </v-col>
            </v-row>
          </v-card>
          <form>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label
                      >{{ $t("messages.general.academicYear") }}
                      <code style="background: none; box-shadow: none;"
                        >*</code
                      ></label
                    >
                  </div>
                  <div class="col no-margin-padding">
                    <AcademicYear
                      :onChanged="onSelYearChangedIncrease"
                      :selectedVal="selYearIncrease"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label
                      >{{ $t("messages.general.semester") }}
                      <code style="background: none; box-shadow: none;"
                        >*</code
                      ></label
                    >
                  </div>
                  <div class="col no-margin-padding">
                    <Semester
                      :onChanged="onSelSemesterChangedIncrease"
                      :selectedVal="selSemesterIncrease"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label
                      >{{ $t("messages.general.educationLvl") }}
                      <code style="background: none; box-shadow: none;"
                        >*</code
                      ></label
                    >
                  </div>
                  <div class="col no-margin-padding">
                    <Level
                      :onChanged="onSelLvlChangedIncrease"
                      :selectedVal="selLvlIncrease"
                      :disabled="false"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label
                      >{{ $t("messages.general.faculty")
                      }}<code style="background: none; box-shadow: none;"
                        >*</code
                      ></label
                    >
                  </div>
                  <div class="col no-margin-padding">
                    <Faculty
                      :onChanged="onSelFacultyChangedIncrease"
                      :selectedVal="selFacultyIncrease"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label
                      >{{ $t("messages.general.classCodeGroup") }}
                      <code style="background: none; box-shadow: none;">*</code>
                    </label>
                  </div>
                  <div class="col no-margin-padding">
                    <div>
                      <select class="form-control" v-model="selCoursegroup">
                        <option
                          v-for="(opt, idx) in selectedCourseGroupOpts"
                          v-bind:key="idx"
                          v-bind:value="opt.value"
                        >
                          {{ opt.text }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 13em;">
                    <label
                      >{{ $t("messages.general.desClassCodeGroup") }}
                      <code style="background: none; box-shadow: none;"
                        >*</code
                      ></label
                    >
                  </div>
                  <div class="col no-margin-padding">
                    <input
                      type="text"
                      class="form-control col mr-2"
                      style="margin-right: 0px !important"
                      v-model="desClassCodeGroup"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              class="form-row flex-column justify-content-center align-items-center mt-5"
            >
              <div class="form-group">
                <div class="form-inline">
                  <button
                    type="button"
                    class="btn btn-primary btn-lg"
                    @click="showSelectClassCodeIncrease()"
                  >
                    {{ $t("messages.general.selectClassCode") }}</button
                  >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <button
                    type="button"
                    class="btn btn-light btn-lg"
                    @click="goBackIncrease()"
                  >
                    {{ $t("messages.general.backhome") }}</button
                  >&nbsp;&nbsp;&nbsp;
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="card" v-if="!isEdit && mode == 'edit'">
        <div class="card-header">
          <v-icon color="pink">description</v-icon>
          <h4>{{ $t("messages.general.showInfo") }}</h4>
        </div>
        <v-card width="100%">
          <v-row> </v-row>
        </v-card>
        <form>
          <div class="information-block">
            <div class="row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 16em;">
                    <div>{{ $t("messages.general.academicYear") }}</div>
                  </div>
                  <div class="col no-margin-padding">
                    <div>{{ selected.ACADYEAR }}</div>
                  </div>
                  <div class="col no-margin-padding">
                    <div></div>
                  </div>
                  <div class="col no-margin-padding">
                    <div></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 16em;">
                    <div>{{ $t("messages.general.semester") }}</div>
                  </div>
                  <div class="col no-margin-padding">
                    <div>{{ selected.SEMESTER }}</div>
                  </div>
                  <div class="col no-margin-padding">
                    <div></div>
                  </div>
                  <div class="col no-margin-padding">
                    <div></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 16em;">
                    <div>{{ $t("messages.general.educationLvl") }}</div>
                  </div>
                  <div class="col no-margin-padding">
                    <div>{{ selected.LEVELNAME }}</div>
                  </div>
                  <div class="col no-margin-padding">
                    <div></div>
                  </div>
                  <div class="col no-margin-padding">
                    <div></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 16em;">
                    <div>{{ $t("messages.general.faculty") }}</div>
                  </div>
                  <div class="col no-margin-padding">
                    <div>{{ this.selectedDetail.FACULTYNAME }}</div>
                  </div>
                  <div class="col no-margin-padding">
                    <div></div>
                  </div>
                  <div class="col no-margin-padding">
                    <div></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 16em;">
                    <div>{{ $t("messages.general.classCodeGroup") }}</div>
                  </div>
                  <div class="col no-margin-padding">
                    <div>{{ this.selected.COURSEGROUP }}</div>
                  </div>
                  <div class="col no-margin-padding">
                    <div></div>
                  </div>
                  <div class="col no-margin-padding">
                    <div></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 16em;">
                    <div>{{ $t("messages.general.desClassCodeGroup") }}</div>
                  </div>
                  <div class="col no-margin-padding">
                    <div>{{ this.selectedDetail.COURSEGROUPDESC }}</div>
                  </div>
                  <div class="col no-margin-padding">
                    <div></div>
                  </div>
                  <div class="col no-margin-padding">
                    <div></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="form-row flex-column justify-content-center align-items-center mt-5"
          >
            <div class="form-group" style="width: 100%">
              <div class="form-inline">
                <div
                  class="form-group"
                  style="width: 60%; justify-content: center;"
                >
                  <div class="form-inline">
                    <button
                      type="button"
                      class="btn btn-primary btn-lg"
                      @click="showSelectClassCode()"
                    >
                      {{ $t("messages.general.selectClassCode") }}</button
                    >&nbsp;&nbsp;&nbsp;
                    <button
                      type="button"
                      class="btn btn-primary btn-lg"
                      @click="handleSelectPersonnel()"
                    >
                      {{ $t("messages.general.selectPersonnel") }}</button
                    >&nbsp;&nbsp;&nbsp;
                    <button
                      type="button"
                      class="btn btn-light btn-lg"
                      @click="goBack()"
                    >
                      {{ $t("messages.general.backhome") }}</button
                    >&nbsp;&nbsp;&nbsp;
                  </div>
                </div>
                <div
                  class="form-group"
                  style="width: 40%; justify-content: flex-end;"
                >
                  <div class="form-inline">
                    <button
                      type="button"
                      class="btn btn-primary btn-lg"
                      @click="
                        selTab == 'tab-1'
                          ? deleteDataCourse()
                          : deleteDataPersonal()
                      "
                      :disabled="
                        (selTab == 'tab-1' &&
                          this.classCodeListTab.length <= 0) ||
                          (selTab == 'tab-2' &&
                            this.personelSelList.length <= 0)
                      "
                    >
                      {{ deleteDataTxt }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <v-tabs v-model="selTab">
              <v-tab href="#tab-1">{{
                $t("messages.general.selectedClass")
              }}</v-tab>
              <v-tab href="#tab-2">{{
                $t("messages.general.personnel")
              }}</v-tab>
              <v-tab-item value="tab-1">
                <v-card flat>
                  <v-card-text>
                    <v-card>
                      <b-table
                        bordered
                        hover
                        small
                        responsive
                        caption-top
                        class="table table-striped text-center"
                        :sort-by.sync="bTableSelectClassCode.sortBy"
                        :sort-desc.sync="bTableSelectClassCode.sortDesc"
                        :items="bTableSelectClassCode.items"
                        :fields="bTableSelectClassCode.fields"
                        :per-page="perPage"
                        :current-page="currentPageSearch"
                      >
                        <template slot="table-caption">
                          <div class="float-left">
                            <b class="mr-2">{{
                              $t("messages.general.table.paginationinfo")
                            }}</b>
                            <b-form-select
                              v-model="perPage"
                              :options="perPageOptions"
                              size="sm"
                              style="width:70px"
                            />
                          </div>
                          <b-pagination
                            class="float-right"
                            size="sm"
                            :total-rows="bTableSelectClassCode.items.length"
                            v-model="currentPageSearch"
                            :per-page="perPage"
                          />
                          <div
                            v-if="bTableSelectClassCode.items.length > 0"
                            class="float-right data-table-page-info"
                          >
                            {{
                              Number(
                                currentPageSearch > 1
                                  ? (currentPageSearch - 1) * perPage + 1
                                  : currentPageSearch
                              ).toLocaleString()
                            }}
                            -
                            {{
                              Number(
                                currentPageSearch * perPage >
                                  bTableSelectClassCode.items.length
                                  ? bTableSelectClassCode.items.length
                                  : currentPageSearch * perPage
                              ).toLocaleString()
                            }}
                            {{ $t("messages.general.fromRecords") }}
                            {{
                              Number(
                                bTableSelectClassCode.items.length
                              ).toLocaleString()
                            }}
                          </div>
                          <div
                            v-if="bTableSelectClassCode.items.length <= 0"
                            class="float-right data-table-page-info"
                          >
                            0 - 0
                            {{ $t("messages.general.fromRecords") }}
                            {{
                              Number(
                                bTableSelectClassCode.items.length
                              ).toLocaleString()
                            }}
                          </div>
                        </template>
                        <template v-slot:head(action)="">
                          <input
                            type="checkbox"
                            id="chkClsAll"
                            @change="handleChkAllClsCodeTab($event)"
                            :checked="
                              bTableSelectClassCode.items.length > 0 &&
                                bTableSelectClassCode.items.length ==
                                  classCodeListTab.length
                            "
                          />
                        </template>
                        <template v-slot:cell(action)="data">
                          <input
                            type="checkbox"
                            id="chkCls"
                            @change="handleChkClsCodeTab($event, data)"
                            :checked="data.value"
                          />
                        </template>
                        <template slot="table-caption">
                          <div
                            style="position: absolute; bottom: -65px; width: 100%; height: 65px; padding-top: 10px; border-color: #fff; box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);"
                          >
                            <div class="float-left">
                              <b class="mr-2">{{
                                $t("messages.general.table.paginationinfo")
                              }}</b>
                              <b-form-select
                                v-model="perPage"
                                :options="perPageOptions"
                                size="sm"
                                style="width:70px"
                              />
                            </div>
                            <b-pagination
                              class="float-right"
                              size="sm"
                              :total-rows="bTableSelectClassCode.items.length"
                              v-model="currentPageSearch"
                              :per-page="perPage"
                              style="padding-top: 10px"
                            />
                            <div
                              v-if="bTableSelectClassCode.items.length > 0"
                              class="float-right data-table-page-info"
                              style="padding-top: 14px"
                            >
                              {{
                                Number(
                                  currentPageSearch > 1
                                    ? (currentPageSearch - 1) * perPage + 1
                                    : currentPageSearch
                                ).toLocaleString()
                              }}
                              -
                              {{
                                Number(
                                  currentPageSearch * perPage >
                                    bTableSelectClassCode.items.length
                                    ? bTableSelectClassCode.items.length
                                    : currentPageSearch * perPage
                                ).toLocaleString()
                              }}
                              {{ $t("messages.general.fromRecords") }}
                              {{
                                Number(
                                  bTableSelectClassCode.items.length
                                ).toLocaleString()
                              }}
                            </div>
                            <div
                              v-if="bTableSelectClassCode.items.length <= 0"
                              class="float-right data-table-page-info"
                              style="padding-top: 14px"
                            >
                              0 - 0
                              {{ $t("messages.general.fromRecords") }}
                              {{
                                Number(
                                  bTableSelectClassCode.items.length
                                ).toLocaleString()
                              }}
                            </div>
                          </div>
                        </template>
                      </b-table>
                    </v-card>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item value="tab-2">
                <v-card flat>
                  <v-card-text>
                    <v-card>
                      <b-table
                        bordered
                        hover
                        small
                        responsive
                        caption-top
                        class="table table-striped text-center"
                        :sort-by.sync="bTableSelectPersonnel.sortBy"
                        :sort-desc.sync="bTableSelectPersonnel.sortDesc"
                        :items="bTableSelectPersonnel.items"
                        :fields="bTableSelectPersonnel.fields"
                        :per-page="perPage"
                        :current-page="currentPageSearch"
                      >
                        <template slot="table-caption">
                          <div class="float-left">
                            <b class="mr-2">{{
                              $t("messages.general.table.paginationinfo")
                            }}</b>
                            <b-form-select
                              v-model="perPage"
                              :options="perPageOptions"
                              size="sm"
                              style="width:70px"
                            />
                          </div>
                          <b-pagination
                            class="float-right"
                            size="sm"
                            :total-rows="bTableSelectPersonnel.items.length"
                            v-model="currentPageSearch"
                            :per-page="perPage"
                          />
                          <div
                            v-if="bTableSelectPersonnel.items.length > 0"
                            class="float-right data-table-page-info"
                          >
                            {{
                              Number(
                                currentPageSearch > 1
                                  ? (currentPageSearch - 1) * perPage + 1
                                  : currentPageSearch
                              ).toLocaleString()
                            }}
                            -
                            {{
                              Number(
                                currentPageSearch * perPage >
                                  bTableSelectPersonnel.items.length
                                  ? bTableSelectPersonnel.items.length
                                  : currentPageSearch * perPage
                              ).toLocaleString()
                            }}
                            {{ $t("messages.general.fromRecords") }}
                            {{
                              Number(
                                bTableSelectPersonnel.items.length
                              ).toLocaleString()
                            }}
                          </div>
                          <div
                            v-if="bTableSelectPersonnel.items.length <= 0"
                            class="float-right data-table-page-info"
                          >
                            0 - 0
                            {{ $t("messages.general.fromRecords") }}
                            {{
                              Number(
                                bTableSelectPersonnel.items.length
                              ).toLocaleString()
                            }}
                          </div>
                        </template>
                        <template v-slot:head(actionSelpersonel)="">
                          <input
                            type="checkbox"
                            id="chkSelAll"
                            @change="handleSelChkAllPersonel($event)"
                            :checked="
                              bTableSelectPersonnel.items.length > 0 &&
                                bTableSelectPersonnel.items.length ==
                                  personelSelList.length
                            "
                          />
                        </template>
                        <template v-slot:cell(actionSelpersonel)="data">
                          <input
                            type="checkbox"
                            id="chkSelpersonel"
                            @change="handleSelChkPersonel($event, data)"
                            :checked="data.value"
                          />
                        </template>
                        <template slot="table-caption">
                          <div
                            style="position: absolute; bottom: -65px; width: 100%; height: 65px; padding-top: 10px; border-color: #fff; box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);"
                          >
                            <div class="float-left">
                              <b class="mr-2">{{
                                $t("messages.general.table.paginationinfo")
                              }}</b>
                              <b-form-select
                                v-model="perPage"
                                :options="perPageOptions"
                                size="sm"
                                style="width:70px"
                              />
                            </div>
                            <b-pagination
                              class="float-right"
                              size="sm"
                              :total-rows="bTableSelectPersonnel.items.length"
                              v-model="currentPageSearch"
                              :per-page="perPage"
                              style="padding-top: 10px"
                            />
                            <div
                              v-if="bTableSelectPersonnel.items.length > 0"
                              class="float-right data-table-page-info"
                              style="padding-top: 14px"
                            >
                              {{
                                Number(
                                  currentPageSearch > 1
                                    ? (currentPageSearch - 1) * perPage + 1
                                    : currentPageSearch
                                ).toLocaleString()
                              }}
                              -
                              {{
                                Number(
                                  currentPageSearch * perPage >
                                    bTableSelectPersonnel.items.length
                                    ? bTableSelectPersonnel.items.length
                                    : currentPageSearch * perPage
                                ).toLocaleString()
                              }}
                              {{ $t("messages.general.fromRecords") }}
                              {{
                                Number(
                                  bTableSelectPersonnel.items.length
                                ).toLocaleString()
                              }}
                            </div>
                            <div
                              v-if="bTableSelectPersonnel.items.length <= 0"
                              class="float-right data-table-page-info"
                              style="padding-top: 14px"
                            >
                              0 - 0
                              {{ $t("messages.general.fromRecords") }}
                              {{
                                Number(
                                  bTableSelectPersonnel.items.length
                                ).toLocaleString()
                              }}
                            </div>
                          </div>
                        </template>
                      </b-table>
                    </v-card>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs>
          </div>
        </form>
      </div>
    </div>
    <v-dialog v-model="dialogSelectPersonnel" max-width="70%">
      <v-card tile>
        <v-toolbar flat dense>
          <v-icon>build</v-icon>
          <v-toolbar-title>{{
            $t("messages.general.selectDataCoorSched")
          }}</v-toolbar-title>
          <div class="flex-grow-1"></div>
          <v-toolbar-items>
            <v-btn icon @click="dialogSelectPersonnel = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text dark>
          <div class="form-row">
            <div class="col no-padding-bottom">
              <div class="information-detail-white">
                <div class="col no-margin-padding" style="flex: 0 0 10em;">
                  <label>{{ $t("messages.general.identity") }}</label>
                </div>
                <div class="col no-margin-padding">
                  <div>
                    <input
                      v-model="dlgIdentity"
                      type="text"
                      class="form-control col mr-2"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="col no-padding-bottom">
              <div class="information-detail-white">
                <div class="col no-margin-padding" style="flex: 0 0 10em;">
                  <label>{{ $t("messages.general.fullname") }}</label>
                </div>
                <div class="col no-margin-padding">
                  <div>
                    <input
                      v-model="dlgFullname"
                      type="text"
                      class="form-control col mr-2"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="form-row flex-column justify-content-center align-items-center mt-5"
          >
            <div class="form-group">
              <div class="form-inline">
                <button
                  class="btn btn-primary btn-lg"
                  type="button"
                  @click="handleSearchPersonel()"
                >
                  {{ $t("messages.general.search") }}</button
                >&nbsp;&nbsp;&nbsp;
                <button
                  class="btn btn-primary btn-lg"
                  type="button"
                  @click="handleSelPersonnel(false)"
                  :disabled="this.personelList.length <= 0"
                >
                  {{ $t("messages.general.select") }}</button
                >&nbsp;&nbsp;&nbsp;
                <button
                  class="btn btn-light btn-lg"
                  type="button"
                  @click="handleSelPersonnel(true)"
                >
                  {{ $t("messages.general.backhome") }}</button
                >&nbsp;&nbsp;&nbsp;
              </div>
            </div>
          </div>
          <v-card>
            <b-table
              bordered
              hover
              small
              responsive
              caption-top
              class="table table-striped text-center"
              :sort-by.sync="bTablePersonnel.sortBy"
              :sort-desc.sync="bTablePersonnel.sortDesc"
              :items="bTablePersonnel.items"
              :fields="bTablePersonnel.fields"
              :per-page="perPage"
              :current-page="currentPageSearch"
            >
              <template slot="table-caption">
                <div class="float-left">
                  <b class="mr-2">{{
                    $t("messages.general.table.paginationinfo")
                  }}</b>
                  <b-form-select
                    v-model="perPage"
                    :options="perPageOptions"
                    size="sm"
                    style="width:70px"
                  />
                </div>
                <b-pagination
                  class="float-right"
                  size="sm"
                  :total-rows="bTablePersonnel.items.length"
                  v-model="currentPageSearch"
                  :per-page="perPage"
                />
                <div
                  v-if="bTablePersonnel.items.length > 0"
                  class="float-right data-table-page-info"
                >
                  {{
                    Number(
                      currentPageSearch > 1
                        ? (currentPageSearch - 1) * perPage + 1
                        : currentPageSearch
                    ).toLocaleString()
                  }}
                  -
                  {{
                    Number(
                      currentPageSearch * perPage > bTablePersonnel.items.length
                        ? bTablePersonnel.items.length
                        : currentPageSearch * perPage
                    ).toLocaleString()
                  }}
                  {{ $t("messages.general.fromRecords") }}
                  {{ Number(bTablePersonnel.items.length).toLocaleString() }}
                </div>
                <div
                  v-if="bTablePersonnel.items.length <= 0"
                  class="float-right data-table-page-info"
                >
                  0 - 0
                  {{ $t("messages.general.fromRecords") }}
                  {{ Number(bTablePersonnel.items.length).toLocaleString() }}
                </div>
              </template>
              <template v-slot:head(action)="">
                <input
                  type="checkbox"
                  id="chkAllpersonel"
                  @change="handleChkAllPersonel($event)"
                  :checked="
                    bTablePersonnel.items.length > 0 &&
                      bTablePersonnel.items.length == personelList.length
                  "
                />
              </template>
              <template v-slot:cell(action)="data">
                <input
                  type="checkbox"
                  id="chkpersonel"
                  @change="handleChkPersonel($event, data)"
                  :checked="data.item.action"
                />
              </template>
              <template slot="table-caption">
                <div
                  style="position: absolute; bottom: -65px; width: 100%; height: 65px; padding-top: 10px; border-color: #fff; box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);"
                >
                  <div class="float-left">
                    <b class="mr-2">{{
                      $t("messages.general.table.paginationinfo")
                    }}</b>
                    <b-form-select
                      v-model="perPage"
                      :options="perPageOptions"
                      size="sm"
                      style="width:70px"
                    />
                  </div>
                  <b-pagination
                    class="float-right"
                    size="sm"
                    :total-rows="bTablePersonnel.items.length"
                    v-model="currentPageSearch"
                    :per-page="perPage"
                    style="padding-top: 10px"
                  />
                  <div
                    v-if="bTablePersonnel.items.length > 0"
                    class="float-right data-table-page-info"
                    style="padding-top: 14px"
                  >
                    {{
                      Number(
                        currentPageSearch > 1
                          ? (currentPageSearch - 1) * perPage + 1
                          : currentPageSearch
                      ).toLocaleString()
                    }}
                    -
                    {{
                      Number(
                        currentPageSearch * perPage >
                          bTablePersonnel.items.length
                          ? bTablePersonnel.items.length
                          : currentPageSearch * perPage
                      ).toLocaleString()
                    }}
                    {{ $t("messages.general.fromRecords") }}
                    {{ Number(bTablePersonnel.items.length).toLocaleString() }}
                  </div>
                  <div
                    v-if="bTablePersonnel.items.length <= 0"
                    class="float-right data-table-page-info"
                    style="padding-top: 14px"
                  >
                    0 - 0
                    {{ $t("messages.general.fromRecords") }}
                    {{ Number(bTablePersonnel.items.length).toLocaleString() }}
                  </div>
                </div>
              </template>
            </b-table>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogSelectClassCode"
      hide-overlay
      scrollable
      max-width="80%"
    >
      <v-card tile>
        <v-toolbar flat dense>
          <v-icon>search</v-icon>
          <v-toolbar-title>{{
            $t("messages.general.selectClassCoorSched")
          }}</v-toolbar-title>
          <div class="flex-grow-1"></div>
          <v-toolbar-items>
            <v-btn icon @click="dialogSelectClassCode = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text dark>
          <v-card width="100%">
            <v-row> </v-row>
          </v-card>
          <form>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 13em;">
                    <label>{{ $t("messages.general.classId") }}</label>
                  </div>
                  <div class="col no-margin-padding">
                    <input
                      type="text"
                      class="form-control col mr-2"
                      style="margin-right: 0px !important"
                      v-model="dlgCourseCode"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 13em;">
                    <label>{{ $t("messages.general.className") }}</label>
                  </div>
                  <div class="col no-margin-padding">
                    <input
                      type="text"
                      class="form-control col mr-2"
                      style="margin-right: 0px !important"
                      v-model="dlgCourseName"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              class="form-row flex-column justify-content-center align-items-center mt-5"
            >
              <div class="form-group">
                <div class="form-inline">
                  <button
                    class="btn btn-primary btn-lg"
                    type="button"
                    @click="handleCourseSearch()"
                  >
                    {{ $t("messages.general.search") }}</button
                  >&nbsp;&nbsp;&nbsp;
                  <button
                    class="btn btn-primary btn-lg"
                    type="button"
                    @click="handleSelClsCode(false)"
                    :disabled="this.classCodeList.length <= 0"
                  >
                    {{ $t("messages.general.select") }}</button
                  >&nbsp;&nbsp;&nbsp;
                  <button
                    class="btn btn-light btn-lg"
                    type="button"
                    @click="handleSelClsCode(true)"
                  >
                    {{ $t("messages.general.backhome") }}</button
                  >&nbsp;&nbsp;&nbsp;
                </div>
              </div>
            </div>
          </form>
          <v-card>
            <b-table
              bordered
              hover
              small
              responsive
              caption-top
              class="table table-striped text-center"
              :sort-by.sync="bTableProgram.sortBy"
              :sort-desc.sync="bTableProgram.sortDesc"
              :items="bTableProgram.items"
              :fields="bTableProgram.fields"
              :per-page="perPage"
              :current-page="currentPageProgram"
            >
              <template slot="table-caption">
                <div class="float-left">
                  <b class="mr-2">{{
                    $t("messages.general.table.paginationinfo")
                  }}</b>
                  <b-form-select
                    v-model="perPage"
                    :options="perPageOptions"
                    size="sm"
                    style="width:70px"
                  />
                </div>
                <b-pagination
                  class="float-right"
                  size="sm"
                  :total-rows="bTableProgram.items.length"
                  v-model="currentPageProgram"
                  :per-page="perPage"
                />
                <div
                  v-if="bTableProgram.items.length > 0"
                  class="float-right data-table-page-info"
                >
                  {{
                    Number(
                      currentPageProgram > 1
                        ? (currentPageProgram - 1) * perPage + 1
                        : currentPageProgram
                    ).toLocaleString()
                  }}
                  -
                  {{
                    Number(
                      currentPageProgram * perPage > bTableProgram.items.length
                        ? bTableProgram.items.length
                        : currentPageProgram * perPage
                    ).toLocaleString()
                  }}
                  {{ $t("messages.general.fromRecords") }}
                  {{ Number(bTableProgram.items.length).toLocaleString() }}
                </div>
                <div
                  v-if="bTableProgram.items.length <= 0"
                  class="float-right data-table-page-info"
                >
                  0 - 0
                  {{ $t("messages.general.fromRecords") }}
                  {{ Number(bTableProgram.items.length).toLocaleString() }}
                </div>
              </template>
              <template v-slot:head(action)="">
                <input
                  type="checkbox"
                  id="chkClsChkAll"
                  @change="handleClsChkAll($event)"
                  :checked="
                    bTableProgram.items.length > 0 &&
                      bTableProgram.items.length == classCodeList.length
                  "
                />
              </template>
              <template v-slot:cell(action)="data">
                <input
                  type="checkbox"
                  id="chkClsChk"
                  @change="handleClsChk($event, data)"
                  :checked="data.item.action"
                />
              </template>
              <template slot="table-caption">
                <div
                  style="position: absolute; bottom: -65px; width: 100%; height: 65px; padding-top: 10px; border-color: #fff; box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);"
                >
                  <div class="float-left">
                    <b class="mr-2">{{
                      $t("messages.general.table.paginationinfo")
                    }}</b>
                    <b-form-select
                      v-model="perPage"
                      :options="perPageOptions"
                      size="sm"
                      style="width:70px"
                    />
                  </div>
                  <b-pagination
                    class="float-right"
                    size="sm"
                    :total-rows="bTableProgram.items.length"
                    v-model="currentPageProgram"
                    :per-page="perPage"
                    style="padding-top: 10px"
                  />
                  <div
                    v-if="bTableProgram.items.length > 0"
                    class="float-right data-table-page-info"
                    style="padding-top: 14px"
                  >
                    {{
                      Number(
                        currentPageProgram > 1
                          ? (currentPageProgram - 1) * perPage + 1
                          : currentPageProgram
                      ).toLocaleString()
                    }}
                    -
                    {{
                      Number(
                        currentPageProgram * perPage >
                          bTableProgram.items.length
                          ? bTableProgram.items.length
                          : currentPageProgram * perPage
                      ).toLocaleString()
                    }}
                    {{ $t("messages.general.fromRecords") }}
                    {{ Number(bTableProgram.items.length).toLocaleString() }}
                  </div>
                  <div
                    v-if="bTableProgram.items.length <= 0"
                    class="float-right data-table-page-info"
                    style="padding-top: 14px"
                  >
                    0 - 0
                    {{ $t("messages.general.fromRecords") }}
                    {{ Number(bTableProgram.items.length).toLocaleString() }}
                  </div>
                </div>
              </template>
            </b-table>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogSelectClassCodeIncrease"
      hide-overlay
      scrollable
      max-width="80%"
    >
      <v-card tile>
        <v-toolbar flat dense>
          <v-icon>search</v-icon>
          <v-toolbar-title>{{
            $t("messages.general.selectClassCoorSched")
          }}</v-toolbar-title>
          <div class="flex-grow-1"></div>
          <v-toolbar-items>
            <v-btn icon @click="dialogSelectClassCodeIncrease = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text dark>
          <v-card width="100%">
            <v-row> </v-row>
          </v-card>
          <form>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 13em;">
                    <label>{{ $t("messages.general.classId") }}</label>
                  </div>
                  <div class="col no-margin-padding">
                    <input
                      type="text"
                      class="form-control col mr-2"
                      style="margin-right: 0px !important"
                      v-model="dlgCourseCodeIncrease"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 13em;">
                    <label>{{ $t("messages.general.className") }}</label>
                  </div>
                  <div class="col no-margin-padding">
                    <input
                      type="text"
                      class="form-control col mr-2"
                      style="margin-right: 0px !important"
                      v-model="dlgCourseNameIncrease"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              class="form-row flex-column justify-content-center align-items-center mt-5"
            >
              <div class="form-group">
                <div class="form-inline">
                  <button
                    class="btn btn-primary btn-lg"
                    type="button"
                    @click="handleCourseSearchIncrease()"
                  >
                    {{ $t("messages.general.search") }}</button
                  >&nbsp;&nbsp;&nbsp;
                  <button
                    class="btn btn-primary btn-lg"
                    type="button"
                    @click="handleSelClsCodeIncrease(false)"
                    :disabled="this.classCodeList.length <= 0"
                  >
                    {{ $t("messages.general.select") }}</button
                  >&nbsp;&nbsp;&nbsp;
                  <button
                    class="btn btn-light btn-lg"
                    type="button"
                    @click="handleSelClsCodeIncrease(true)"
                  >
                    {{ $t("messages.general.backhome") }}</button
                  >&nbsp;&nbsp;&nbsp;
                </div>
              </div>
            </div>
          </form>
          <v-card>
            <b-table
              bordered
              hover
              small
              responsive
              caption-top
              class="table table-striped text-center"
              :sort-by.sync="bTableProgram.sortBy"
              :sort-desc.sync="bTableProgram.sortDesc"
              :items="bTableProgram.items"
              :fields="bTableProgram.fields"
              :per-page="perPage"
              :current-page="currentPageProgram"
            >
              <template slot="table-caption">
                <div class="float-left">
                  <b class="mr-2">{{
                    $t("messages.general.table.paginationinfo")
                  }}</b>
                  <b-form-select
                    v-model="perPage"
                    :options="perPageOptions"
                    size="sm"
                    style="width:70px"
                  />
                </div>
                <b-pagination
                  class="float-right"
                  size="sm"
                  :total-rows="bTableProgram.items.length"
                  v-model="currentPageProgram"
                  :per-page="perPage"
                />
                <div
                  v-if="bTableProgram.items.length > 0"
                  class="float-right data-table-page-info"
                >
                  {{
                    Number(
                      currentPageProgram > 1
                        ? (currentPageProgram - 1) * perPage + 1
                        : currentPageProgram
                    ).toLocaleString()
                  }}
                  -
                  {{
                    Number(
                      currentPageProgram * perPage > bTableProgram.items.length
                        ? bTableProgram.items.length
                        : currentPageProgram * perPage
                    ).toLocaleString()
                  }}
                  {{ $t("messages.general.fromRecords") }}
                  {{ Number(bTableProgram.items.length).toLocaleString() }}
                </div>
                <div
                  v-if="bTableProgram.items.length <= 0"
                  class="float-right data-table-page-info"
                >
                  0 - 0
                  {{ $t("messages.general.fromRecords") }}
                  {{ Number(bTableProgram.items.length).toLocaleString() }}
                </div>
              </template>
              <template v-slot:head(action)="">
                <input
                  type="checkbox"
                  id="chkClsChkAll"
                  @change="handleClsChkAll($event)"
                  :checked="
                    bTableProgram.items.length > 0 &&
                      bTableProgram.items.length == classCodeList.length
                  "
                />
              </template>
              <template v-slot:cell(action)="data">
                <input
                  type="checkbox"
                  id="chkClsChk"
                  @change="handleClsChk($event, data)"
                  :checked="data.item.action"
                />
              </template>
              <template slot="table-caption">
                <div
                  style="position: absolute; bottom: -65px; width: 100%; height: 65px; padding-top: 10px; border-color: #fff; box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);"
                >
                  <div class="float-left">
                    <b class="mr-2">{{
                      $t("messages.general.table.paginationinfo")
                    }}</b>
                    <b-form-select
                      v-model="perPage"
                      :options="perPageOptions"
                      size="sm"
                      style="width:70px"
                    />
                  </div>
                  <b-pagination
                    class="float-right"
                    size="sm"
                    :total-rows="bTableProgram.items.length"
                    v-model="currentPageProgram"
                    :per-page="perPage"
                    style="padding-top: 10px"
                  />
                  <div
                    v-if="bTableProgram.items.length > 0"
                    class="float-right data-table-page-info"
                    style="padding-top: 14px"
                  >
                    {{
                      Number(
                        currentPageProgram > 1
                          ? (currentPageProgram - 1) * perPage + 1
                          : currentPageProgram
                      ).toLocaleString()
                    }}
                    -
                    {{
                      Number(
                        currentPageProgram * perPage >
                          bTableProgram.items.length
                          ? bTableProgram.items.length
                          : currentPageProgram * perPage
                      ).toLocaleString()
                    }}
                    {{ $t("messages.general.fromRecords") }}
                    {{ Number(bTableProgram.items.length).toLocaleString() }}
                  </div>
                  <div
                    v-if="bTableProgram.items.length <= 0"
                    class="float-right data-table-page-info"
                    style="padding-top: 14px"
                  >
                    0 - 0
                    {{ $t("messages.general.fromRecords") }}
                    {{ Number(bTableProgram.items.length).toLocaleString() }}
                  </div>
                </div>
              </template>
            </b-table>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogCopyFacSem" max-width="600px">
      <v-card tile>
        <v-toolbar flat dense>
          <v-icon>edit</v-icon>
          <v-toolbar-title>{{
            $t("messages.general.manageData")
          }}</v-toolbar-title>
          <div class="flex-grow-1"></div>
          <v-toolbar-items>
            <v-btn icon @click="dialogCopyFacSem = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text dark>
          <div class="form-row">
            <div class="col no-padding-bottom">
              <div class="information-detail-white">
                <div class="col no-margin-padding" style="flex: 0 0 10em;">
                  <label
                    >{{ $t("messages.general.academicYear") }}
                    <code style="background: none; box-shadow: none;"
                      >*</code
                    ></label
                  >
                </div>
                <div class="col no-margin-padding">
                  <AcademicYear
                    :onChanged="onDlgSelYearChanged"
                    :selectedVal="dlgselYear"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="col no-padding-bottom">
              <div class="information-detail-white">
                <div class="col no-margin-padding" style="flex: 0 0 10em;">
                  <label
                    >{{ $t("messages.general.semester") }}
                    <code style="background: none; box-shadow: none;"
                      >*</code
                    ></label
                  >
                </div>
                <div class="col no-margin-padding">
                  <Semester
                    :onChanged="onDlgSelSemesterChanged"
                    :selectedVal="dlgselSemester"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="col no-padding-bottom">
              <div class="information-detail-white">
                <div class="col no-margin-padding" style="flex: 0 0 16em;">
                  <label
                    >{{ $t("messages.general.copyAcademicYear") }}
                    <code style="background: none; box-shadow: none;"
                      >*</code
                    ></label
                  >
                </div>
                <div class="col no-margin-padding">
                  <AcademicYear
                    :onChanged="onSelYearChangedCopy"
                    :selectedVal="selYearCopy"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="col no-padding-bottom">
              <div class="information-detail-white">
                <div class="col no-margin-padding" style="flex: 0 0 16em;">
                  <label
                    >{{ $t("messages.general.copySemester") }}
                    <code style="background: none; box-shadow: none;"
                      >*</code
                    ></label
                  >
                </div>
                <div class="col no-margin-padding">
                  <Semester
                    :onChanged="onSelSemesterChangedCopy"
                    :selectedVal="selSemesterCopy"
                  />
                </div>
              </div>
            </div>
          </div>
          <div
            class="form-row flex-column justify-content-center align-items-center mt-5"
          >
            <div class="form-group">
              <div class="form-inline">
                <button
                  type="button"
                  class="btn btn-primary btn-lg"
                  @click="courseYearSemcopy()"
                >
                  {{ $t("messages.general.copy") }}</button
                >&nbsp;&nbsp;&nbsp;
              </div>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogConfirmSuccess" max-width="600px">
      <v-card tile>
        <v-toolbar flat dense color="light-green accent-3">
          <v-icon color="light-green darken-2">fa-check</v-icon>
          <v-toolbar-title style="color: green;"
            >&nbsp;{{
              $t("messages.reqRegister.confirmPopupText")
            }}</v-toolbar-title
          >
          <div class="flex-grow-1"></div>
          <v-toolbar-items>
            <v-btn icon @click="dialogConfirmSuccess = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text dark color="green accent-1">
          <br />
          <span v-html="successText" style="color: green;">{{
            successText
          }}</span>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogError" max-width="600px">
      <v-card tile>
        <v-toolbar flat dense color="red darken-3">
          <v-icon color="red lighten-5">fa-exclamation-circle</v-icon>
          <v-toolbar-title style="color: #ffebee;"
            >&nbsp;{{ dialogErrorTitle }}</v-toolbar-title
          >
          <div class="flex-grow-1"></div>
          <v-toolbar-items>
            <v-btn icon @click="dialogError = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text dark color="red accent-1">
          <br />
          <span style="color: red;" v-html="errorText">{{ errorText }}</span>
        </v-card-text>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
import _ from "lodash";
import { mapGetters, mapActions } from "vuex";

import AcademicYear from "../components/Dropdown/AcademicYear";
import Semester from "../components/Dropdown/Semester";
import Level from "@/components/Dropdown/Level.vue";
import Faculty from "@/components/Dropdown/Faculty.vue";
import Department from "@/components/Dropdown/Department.vue";
import MasterDataProvider from "@/services/masterData_provider";
import EnrollProvider from "@/services/enroll_provider";
import ClassType from "@/components/Dropdown/ClassType";
import ClassProvider from "@/services/class_provider";

const masterDataProvider = new MasterDataProvider();
const enrollProvider = new EnrollProvider();
// eslint-disable-next-line no-unused-vars
const classProvider = new ClassProvider();

export default {
  name: "setCoorSchedForCourse",
  components: {
    AcademicYear,
    Semester,
    Level,
    Faculty,
    Department,
    ClassType,
  },
  data() {
    return {
      selTab: "",
      dialogSelectClassCodeIncrease: false,
      dialogSelectClassCode: false,
      dialogCopyFacSem: false,
      dialogSelectPersonnel: false,
      dlgAddSelCourseCode: "",
      dlgAddSelCourseName: "",
      selYear: 0,
      selSemester: 0,
      selYearIncrease: 0,
      selSemesterIncrease: 0,
      selLvlIncrease: 0,
      selFacultyIncrease: 0,
      //selCoursegroup: 0,
      desClassCodeGroup: "",
      dlgIdentity: "",
      dlgFullname: "",
      selLvl: 0,
      selSection: "00",
      selConfirm: "0",
      courseCode: "",
      courseName: "",
      sections: [],
      structure: false,
      items: [],
      classCodeList: [],
      classCodeListTab: [],
      personelList: [],
      personelSelList: [],
      mode: "",
      selCoursegroup: 0,
      tempCoordinatorcoursefac: [],
      selectedCourseGroupOpts: [
        { text: this.$t("messages.general.notSpecified"), value: 0 },
        { text: "1", value: 1 },
        { text: "2", value: 2 },
        { text: "3", value: 3 },
        { text: "4", value: 4 },
        { text: "5", value: 5 },
        { text: "6", value: 6 },
        { text: "7", value: 7 },
        { text: "8", value: 8 },
        { text: "9", value: 9 },
        { text: "10", value: 10 },
        { text: "11", value: 11 },
        { text: "12", value: 12 },
        { text: "13", value: 13 },
        { text: "14", value: 14 },
        { text: "15", value: 15 },
        { text: "16", value: 16 },
        { text: "17", value: 17 },
        { text: "18", value: 18 },
        { text: "19", value: 19 },
        { text: "20", value: 20 },
        { text: "21", value: 21 },
        { text: "22", value: 22 },
        { text: "23", value: 23 },
        { text: "24", value: 24 },
        { text: "25", value: 25 },
        { text: "26", value: 26 },
        { text: "27", value: 27 },
        { text: "28", value: 28 },
        { text: "29", value: 29 },
        { text: "30", value: 30 },
      ],

      bTableProgram: {
        sortBy: "rowNumber",
        sortDesc: false,
        items: [],
        fields: [
          {
            key: "action",
            label: "",
            thClass: "align-middle",
            thStyle: "width: 50px",
            sortable: true,
          },
          {
            key: "rowNumber",
            label: this.$t("messages.general.seqOrder"),
            thClass: "align-middle",
            thStyle: "width: 50px",
            sortable: true,
          },
          {
            key: "COURSECODE",
            label: this.$t("messages.general.classId"),
            thClass: "align-middle",
            thStyle: "width: 100px",
            sortable: true,
          },
          {
            key: "COURSENAME",
            label: this.$t("messages.general.className"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp col-250",
            sortable: true,
          },
          {
            key: "FACULTYNAME",
            label: this.$t("messages.general.faculty"),
            thClass: "align-middle",
            tdClass: "text-center text-nowarp col-150",
            sortable: true,
          },
          {
            key: "DEPARTMENTNAME",
            label: this.$t("messages.general.department"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp  col-150",
            sortable: true,
          },
          {
            key: "COURSEUNIT",
            label: this.$t("messages.general.credit"),
            thClass: "align-middle",
            thStyle: "width: 100px",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
        ],
      },
      bTable: {
        sortBy: "rowNumber",
        sortDesc: false,
        items: [],
        fields: [
          {
            key: "action",
            label: "",
            thClass: "align-middle",
            sortable: true,
          },
          {
            key: "rowNumber",
            label: this.$t("messages.general.seqOrder"),
            thClass: "align-middle",
            thStyle: "width: 50px",
            sortable: true,
          },
          {
            key: "ACADYEAR",
            label: this.$t("messages.general.academicYear"),
            thClass: "align-middle",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "SEMESTER",
            label: this.$t("messages.general.semester"),
            thClass: "align-middle",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "LEVELNAME",
            label: this.$t("messages.general.educationLvl"),
            thClass: "align-middle",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "FACULTYNAME",
            label: this.$t("messages.general.faculty"),
            thClass: "align-middle",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "COURSEDES",
            label: this.$t("messages.general.classCodeGroup"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
        ],
      },
      bTableSelectClassCode: {
        sortBy: "rowNumber",
        sortDesc: false,
        items: [],
        fields: [
          {
            key: "rowNumber",
            label: this.$t("messages.general.seqOrder"),
            thClass: "align-middle",
            thStyle: "width: 50px",
            sortable: true,
          },
          {
            key: "COURSECODE",
            label: this.$t("messages.general.classId"),
            thClass: "align-middle",
            thStyle: "width: 120px",
            sortable: true,
          },
          {
            key: "COURSENAME",
            label: this.$t("messages.general.className"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
          {
            key: "FACULTYNAME",
            label: this.$t("messages.general.faculty"),
            thClass: "align-middle",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "action",
            label: "",
            thClass: "align-middle",
            sortable: true,
          },
        ],
      },
      bTableSelectPersonnel: {
        sortBy: "rowNumber",
        sortDesc: false,
        items: [],
        fields: [
          {
            key: "rowNumber",
            label: this.$t("messages.general.seqOrder"),
            thClass: "align-middle",
            sortable: true,
          },
          {
            key: "OFFICERCODE",
            label: this.$t("messages.general.identity"),
            thClass: "align-middle",
            sortable: true,
          },
          {
            key: "OFFICERNAME",
            label: this.$t("messages.general.fullname"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
          {
            key: "FACULTYNAME",
            label: this.$t("messages.general.underFac"),
            thClass: "align-middle",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "GENDER",
            label: this.$t("messages.general.gender"),
            thClass: "align-middle",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "actionSelpersonel",
            label: "",
            thClass: "align-middle",
            thStyle: "width: 50px",
            sortable: true,
          },
        ],
      },
      bTablePersonnel: {
        sortBy: "rowNumber",
        sortDesc: false,
        items: [],
        fields: [
          {
            key: "action",
            label: "",
            thClass: "align-middle",
            thStyle: "width: 50px",
            sortable: true,
          },
          {
            key: "rowNumber",
            label: this.$t("messages.general.seqOrder"),
            thClass: "align-middle",
            thStyle: "width: 50px",
            sortable: true,
          },
          {
            key: "OFFICERCODE",
            label: this.$t("messages.general.identity"),
            thClass: "align-middle",
            thStyle: "width: 120px",
            sortable: true,
          },
          {
            key: "NAME",
            label: this.$t("messages.general.fullname"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
          {
            key: "FACULTYNAME",
            label: this.$t("messages.general.underFac"),
            thClass: "align-middle",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "GENDER",
            label: this.$t("messages.general.gender"),
            thClass: "align-middle",
            thStyle: "width: 100px",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
        ],
      },
      perPageOptions: [
        { value: 10, text: 10 },
        { value: 50, text: 50 },
        { value: 100, text: 100 },
        { value: 500, text: 500 },
        { value: 1000, text: 1000 },
        { value: 2000, text: 2000 },
        { value: 3000, text: 3000 },
      ],
      perPage: 100,
      perPageStudentReg: 50,
      currentPage: 1,
      currentPageSearch: 1,
      currentPageProgram: 1,
      searched: false,
      selected: false,
      selectedIdx: 0,
      isEdit: false,
      selectedDetail: false,
      dialogConfirmSuccess: false,
      successText: "",
      dialogError: false,
      errorText: "",
      dialogErrorTitle: "",
      selSemesterCopy: 0,
      selYearCopy: 0,
      dlgselYear: 0,
      dlgselSemester: 0,
      dlgCourseCode: "",
      dlgCourseName: "",
      dlgCourseCodeIncrease: "",
      dlgCourseNameIncrease: "",
      deleteDataTxt: this.$t("messages.general.delCourseData"),
    };
  },
  computed: {
    ...mapGetters("application", {
      appInfo: "getUserInfo",
      token: "getToken",
      userId: "getUserId",
      mfuUserId: "getMfuUserId",
    }),
    currentLang: function() {
      return this.appInfo.currentLocale;
    },
  },
  mounted() {
    this.tokenHealthChk();
    this.togglePreLoader(true);
    this.selYear = this.appInfo.data.ENROLL_ACADYEAR;
    this.selSemester = this.appInfo.data.ENROLL_SEMESTER;
    this.selLvl = 3;
    this.dlgselYear = this.appInfo.data.ENROLL_ACADYEAR;
    this.dlgselSemester = this.appInfo.data.ENROLL_SEMESTER;
    this.selYearIncrease = this.appInfo.data.ENROLL_ACADYEAR;
    this.selSemesterIncrease = this.appInfo.data.ENROLL_SEMESTER;
    this.selLvlIncrease = 3;
    this.selSection = "00";
    this.selConfirm = "0";
    this.selTab = "tab-1";
    this.togglePreLoader(false);
  },
  methods: {
    ...mapActions("application", ["togglePreLoader", "tokenHealthChk"]),
    onSelYearChanged(event) {
      this.selYear = parseInt(event.target.value);
    },
    onSelSemesterChanged(event) {
      this.selSemester = parseInt(event.target.value);
    },
    onDlgSelYearChanged(event) {
      this.dlgselYear = parseInt(event.target.value);
    },
    onDlgSelSemesterChanged(event) {
      this.dlgselSemester = parseInt(event.target.value);
    },
    onSelYearChangedIncrease(event) {
      this.selYearIncrease = parseInt(event.target.value);
    },
    onSelSemesterChangedIncrease(event) {
      this.selSemesterIncrease = parseInt(event.target.value);
    },
    onSelYearChangedCopy(event) {
      this.selYearCopy = parseInt(event.target.value);
    },
    onSelSemesterChangedCopy(event) {
      this.selSemesterCopy = parseInt(event.target.value);
    },
    onSelLvlChangedIncrease(event) {
      this.selLvlIncrease = parseInt(event.target.value);
    },
    onSelFacultyChangedIncrease(event) {
      this.selFacultyIncrease = parseInt(event.target.value);
    },
    onSelLvlChanged(event) {
      this.selLvl = parseInt(event.target.value);
    },
    handleClsChkAll(e) {
      const isChecked = e.target.checked;
      this.bTableProgram.items.map((i) => {
        i.action = e.target.checked;
        if (isChecked) {
          this.classCodeList.push(i.STUDENTID);
        }
      });
      if (!isChecked) {
        this.classCodeList = [];
      }
    },
    handleClsChk(e, data) {
      const isChecked = e.target.checked;
      const { item, index } = data;
      console.log("item", item);
      const tmp = this.bTableProgram.items.find(i => i.CLASSID == data.item.CLASSID);
      if (tmp) {
        tmp.action = isChecked;
        item.action = isChecked;
      }
      // this.bTableProgram.items[index].action = isChecked;
      if (isChecked) {
        this.classCodeList.push(item.CLASSID);
      } else {
        const newArr = this.classCodeList.filter((s) => s != item.STUDENTID);
        this.classCodeList = newArr;
      }
    },
    handleChkAllClsCodeTab(e) {
      const isChecked = e.target.checked;
      this.bTableSelectClassCode.items.map((i) => {
        i.action = e.target.checked;
        if (isChecked) {
          this.classCodeListTab.push(i.COURSECODE);
        }
      });
      if (!isChecked) {
        this.classCodeListTab = [];
      }
    },
    handleChkClsCodeTab(e, data) {
      const isChecked = e.target.checked;
      const { item, index } = data;
      this.bTableSelectClassCode.items[index].action = isChecked;
      if (isChecked) {
        this.classCodeListTab.push(item.COURSECODE);
      } else {
        const newArr = this.classCodeListTab.filter(
          (s) => s != item.OFFICERCODE
        );
        this.classCodeListTab = newArr;
      }
    },
    //เลือกบุคลการทั้งหมด ใน popup
    handleChkAllPersonel(e) {
      const isChecked = e.target.checked;
      this.bTablePersonnel.items.map((i) => {
        i.action = e.target.checked;
        if (isChecked) {
          this.personelList.push(i.OFFICERCODE);
        }
      });
      if (!isChecked) {
        this.personelList = [];
      }
    },
    //เลือกบุคลการที่ต้องการ ใน popup
    handleChkPersonel(e, data) {
      const isChecked = e.target.checked;
      const { item, index } = data;
      this.bTablePersonnel.items[index].action = isChecked;
      if (isChecked) {
        this.personelList.push(item.OFFICERCODE);
      } else {
        const newArr = this.personelList.filter((s) => s != item.OFFICERCODE);
        this.personelList = newArr;
      }
    },
    //checkbox เลือกลบบุคลากรทั้งหมด ในตารางหน้า edit
    handleSelChkAllPersonel(e) {
      const isChecked = e.target.checked;
      this.bTableSelectPersonnel.items.map((i) => {
        i.actionSelpersonel = e.target.checked;
        if (isChecked) {
          this.personelSelList.push(i.OFFICERCODE);
        }
      });
      if (!isChecked) {
        this.personelSelList = [];
      }
    },
    //checkbox ลบบุคลากรตามที่เลือกใน  ในตารางหน้า edit
    handleSelChkPersonel(e, data) {
      const isChecked = e.target.checked;
      const { item, index } = data;
      this.bTableSelectPersonnel.items[index].actionSelpersonel = isChecked;
      if (isChecked) {
        this.personelSelList.push(item.OFFICERCODE);
      } else {
        const newArr = this.personelSelList.filter(
          (s) => s != item.OFFICERCODE
        );
        this.personelSelList = newArr;
      }
      console.log("personeSelList handleSelChkPersonel ", this.personelSelList);
    },
  //ปุ่มลบบุคลากรทั้งหมด
    async deleteDataPersonal() {
      this.togglePreLoader(true);
      let temp = [];
      const found = this.bTableSelectPersonnel.items.filter(
        (i) => i.actionSelpersonel == true
      );
      if (found.length > 0) {
        found.forEach((f) => {
          this.tempCoordinatorcoursefac
            .filter((t) => t.OFFICERCODE == f.OFFICERCODE)
            .forEach((ii) => {
              temp.push(ii.COORDINATOR_DTL_ID);
            });
        });
      }
      console.log( "found deleteDataPersonal ", found);
      console.log( "tempCoordinatorcoursefac deleteDataPersonal ", this.tempCoordinatorcoursefac);
      console.log( "temp deleteDataPersonal ", temp);
      const res = await enrollProvider.deleteCoordinatorCoursebyins({
        token: this.token,
        request: {
          coordinator_dtl_id: temp,
          lang: this.currentLang,
        },
      });

      this.togglePreLoader(false);
      if (res.status == 200) {
        this.dialogConfirmSuccess = true;
        this.successText = `${res.message}<br/>`;
        this.getReqConfirmDetailTabPersonel();
         this.personelSelList = [];
      } else {
        this.dialogErrorTitle = "";
        this.dialogError = true;
        this.errorText = `${res.message}<br/>`;
      }
    },

    async deleteDataCourse() {
      this.togglePreLoader(true);
      const res = await enrollProvider.deleteCoursebycourse({
        token: this.token,
        request: {
          coordinator_hd_id: this.bTableSelectClassCode.items
            .filter((i) => i.action == true)
            .map((ii) => ii.COORDINATOR_HD_ID),
          classid: this.bTableSelectClassCode.items
            .filter((i) => i.action == true)
            .map((ii) => ii.CLASSID),
          lang: this.currentLang,
        },
      });
      console.log("res", res);
      this.togglePreLoader(false);
      if (res.status == 200) {
        this.dialogConfirmSuccess = true;
        this.successText = `${res.message}<br/>`;
        this.getReqConfirmDetail();
      } else {
        this.dialogErrorTitle = "";
        this.dialogError = true;
        this.errorText = `${res.message}<br/>`;
      }
    },
    async handleSearchConfirmResult() {
      if (this.selYear != 0 && this.selSemester != 0 && this.selLvl != -1) {
        this.togglePreLoader(true);
        const result = await enrollProvider.getCoordinatorcourse({
          token: this.token,
          request: {
            acadyear: this.selYear,
            semester: this.selSemester,
            levelid: this.selLvl,
            lang: this.currentLang,
          },
        });
        console.log("result", result);
        this.bTable.items = [];
        if (result.length > 0) {
          let idx = 0;
          result.map((d) => {
            d.rowNumber = idx + 1;
            this.bTable.items.push(d);
            idx++;
          });
          // let filterTemp = [];
          // temp.forEach((t) => {
          //   const lstFound = filterTemp.filter(
          //     (ft) => ft.OFFICERID == t.OFFICERID
          //   );
          //   if (lstFound.length <= 0) {
          //     filterTemp.push(t);
          //   }
          // });
          // this.bTable.items = filterTemp;
        }
        this.togglePreLoader(false);
      }
    },
    showSelectClassCodeIncrease() {
      if (
        this.selYearIncrease != 0 &&
        this.selSemesterIncrease != 0 &&
        this.selLvlIncrease != 0 &&
        this.selFacultyIncrease != 0 &&
        this.selCoursegroup != 0 &&
        this.desClassCodeGroup != ""
      ) {
        this.dialogSelectClassCodeIncrease = true;
      }
    },
    goBackIncrease() {
      this.selYearIncrease = this.appInfo.data.ENROLL_ACADYEAR;
      this.selSemesterIncrease = this.appInfo.data.ENROLL_SEMESTER;
      this.selLvlIncrease = -1;
      this.selFacultyIncrease = 0;
      this.selCoursegroup = 0;
      (this.desClassCodeGroup = ""), (this.isEdit = false);
      this.mode = "";
    },
    showSelectClassCode() {
      this.dialogSelectClassCode = true;
      this.dlgCourseCode = "";
      this.dlgCourseName = "";
    },
    handleCopyData() {
      this.dialogCopyFacSem = true;
    },
    handleSelectPersonnel() {
      this.dialogSelectPersonnel = true;
      this.dlgFullname = "";
      this.dlgIdentity = "";
      this.bTablePersonnel.items.action = false;
      this.handleSearchPersonel();
    },
    handleClearScreen() {
      this.selYear = this.appInfo.data.ENROLL_ACADYEAR;
      this.selSemester = this.appInfo.data.ENROLL_SEMESTER;
      this.selLvl = 3;
      this.bTable.items = [];
    },
    increase() {
      this.selYearIncrease = this.selYear;
      this.selSemesterIncrease = this.selSemester;
      this.selLvlIncrease = this.selLvl;
      this.selCoursegroup = -1;
      this.desClassCodeGroup = "";
      this.goTo(-1, -1, "increase");
    },
    goTo(item, index, mode) {
      this.mode = mode;
      if (mode == "edit") {
        this.selTab = "tab-1";
        this.dialogSelectClassCode = false;
        this.dialogSelectPersonnel = false;
        this.dialogCopyFacSem = false;
        this.selectedIdx = index;
        if (index > -1) {
          this.selected = item;
        } else {
          this.selected = {};
          this.setReqConfirmDetailIncrease();
        }
        this.getReqConfirmDetail(true);
        this.getReqConfirmDetailTabPersonel();
      } else if (mode == "deleteGroup") {
        this.handleDeleteGroup();
      } else {
        console.log("increase");
      }
    },

    async handleDeleteGroup(data) {
      console.log("data", data);
      this.togglePreLoader(true);
      const res = await enrollProvider.deleteCoordinatorcourse({
        token: this.token,
        request: {
          acadyear: this.selYear,
          semester: this.selSemester,
          levelid: this.selLvl,
          facultyid: +data.item.FACULTYID,
          coursegroup: +data.item.COURSEGROUP,
          lang: this.currentLang,
        },
      });
      console.log("res", res);
      this.togglePreLoader(false);
      if (res.status == 200) {
        this.dialogConfirmSuccess = true;
        this.successText = `${res.message}<br/>`;
        this.handleSearchConfirmResult();
      } else {
        this.dialogErrorTitle = "";
        this.dialogError = true;
        this.errorText = `${res.message}<br/>`;
      }
    },
    async setReqConfirmDetailIncrease() {
      this.selected.ACADYEAR = this.selYearIncrease;
      this.selected.SEMESTER = this.selSemesterIncrease;
      this.selected.LEVELID = this.selLvlIncrease;
      this.selected.LEVELNAME = this.selLvlIncrease;
      this.selected.FACULTYID = this.selFacultyIncrease;
      this.selected.COURSEGROUP = this.selCoursegroup;
    },
    async getReqConfirmDetail(isFromCreate = false) {
      this.togglePreLoader(true);
      const result = await enrollProvider.getCoordinatorcoursefac({
        token: this.token,
        request: {
          acadyear: this.selected.ACADYEAR,
          semester: this.selected.SEMESTER,
          levelid: this.selected.LEVELID,
          facultyid: this.selected.FACULTYID,
          coursegroup: this.selected.COURSEGROUP,
          lang: this.currentLang,
        },
      });
      this.bTableSelectClassCode.items = [];
      if (result.length > 0) {
        this.selectedDetail = result[0];
        if (isFromCreate) {
          this.selected.COORDINATOR_HD_ID = result[0].COORDINATOR_HD_ID;
          this.selected.COURSEDES = result[0].COURSEGROUPDESC;
        }

        var groupByData = _.chain(result.filter((r) => r.COURSECODE != null))
          .groupBy("COURSECODE")
          .map((value, key) => ({ officercode: key, data: value }))
          .value();
        const temp = groupByData.map((d, idx) => {
          return {
            ...d.data[0],
            rowNumber: idx + 1,
          };
        });

        this.bTableSelectClassCode.items = temp;
      }
      this.togglePreLoader(false);
    },
    goBack() {
      this.isEdit = false;
      this.mode = "";
      this.handleSearchConfirmResult();
    },
    async handleSearchPersonel() {
      this.togglePreLoader(true);
      const result = await enrollProvider.getCoordinatorbyofficer({
        token: this.token,
        request: {
          officercode: this.dlgIdentity,
          officername: this.dlgFullname,
          facultyid: this.selected.FACULTYID,
          lang: this.currentLang,
        },
      });
      this.bTablePersonnel.items = [];
      if (result.length > 0) {
        let idx = 0;
        const temp = result.map((d, idx) => {
          return {
            ...d,
            rowNumber: idx + 1,
            action: false,
          };
        });
        this.bTablePersonnel.items = temp;

        // let filterTemp = [];
        // temp.forEach((t) => {
        //   const lstFound = filterTemp.filter(
        //     (ft) => ft.OFFICERID == t.OFFICERID
        //   );
        //   if (lstFound.length <= 0) {
        //     filterTemp.push(t);
        //   }
        // });
        // this.bTablePersonnel.items = filterTemp;
      }
      this.togglePreLoader(false);
    },
    async courseYearSemcopy() {
      this.dialogCopyFacSem = false;
      this.togglePreLoader(true);
      const req = {
        token: this.token,
        request: {
          acadyear: this.dlgselYear,
          semester: this.dlgselSemester,
          acadyeardup: +this.selYearCopy,
          semesterdup: +this.selSemesterCopy,
          userid: this.mfuUserId,
          lang: this.currentLang,
        },
      };
      console.log("req", req);
      const res = await enrollProvider.postCoordinatorCourseCopy(req);
      this.togglePreLoader(false);
      if (res.status == 200) {
        this.dialogConfirmSuccess = true;
        this.successText = `${res.message}<br/>`;
      } else {
        this.dialogErrorTitle = "";
        this.dialogError = true;
        this.errorText = `${res.message}<br/>`;
      }
    },
    //ปุ่มกด "เลือก" บุคลากร
    async handleSelPersonnel(isClose) {
      this.dialogSelectPersonnel = false;
      if (!isClose) {
        this.selTab = "tab-2";
        const tempCourse = this.bTableSelectClassCode.items;
        const temp = this.bTablePersonnel.items.filter((i) => i.action == true);

        console.log("temp handleSelPersonnel", temp);
        console.log("tempCourse ", tempCourse);

        this.togglePreLoader(true);
        const res = await enrollProvider.postcoordinatorcourselist({
          token: this.token,
          request: {
            coordinator_hd_id: tempCourse.map((tc) => tc.COORDINATOR_HD_ID),
            officerid: temp.map((t) => t.OFFICERID),
            lang: this.currentLang,
          },
        });
        this.togglePreLoader(false);
        if (res.status == 200) {
          this.dialogConfirmSuccess = true;
          this.successText = `${res.message}<br/>`;
          this.getReqConfirmDetailTabPersonel(true);
        } else {
          this.dialogErrorTitle = "";
          this.dialogError = true;
          this.errorText = `${res.message}<br/>`;
        }
      }
      this.personelList = [];
    },
    async getReqConfirmDetailTabPersonel(fromSel = false) {
      this.togglePreLoader(true);
      const result = await enrollProvider.getCoordinatorcoursefac({
        token: this.token,
        request: {
          acadyear: this.selected.ACADYEAR,
          semester: this.selected.SEMESTER,
          levelid: this.selected.LEVELID,
          facultyid: this.selected.FACULTYID,
          coursegroup: this.selected.COURSEGROUP,
          lang: this.currentLang,
        },
      });
      this.bTableSelectPersonnel.items = [];
      if (result.length > 0) {
        if (fromSel) {
          const temp = this.bTablePersonnel.items.filter(
            (i) => i.action == true
          );
        }
        this.tempCoordinatorcoursefac = result;
        var groupByData = _.chain(result.filter((r) => r.OFFICERCODE != null))
          .groupBy("OFFICERCODE")
          .map((value, key) => ({ officercode: key, data: value }))
          .value();
        const temp = groupByData.map((d, idx) => {
          return {
            ...d.data[0],
            rowNumber: idx + 1,
          };
        });
        this.bTableSelectPersonnel.items = temp;
      }
      this.togglePreLoader(false);
    },

    async handleSelClsCode(isClose) {
      const temp = this.bTableProgram.items.filter((i) => i.action);
      console.log("temp handleSelClsCode", temp);
      this.togglePreLoader(true);
      if (!isClose) {
        this.selTab = "tab-1";
        const temp = this.bTableProgram.items.filter((i) => i.action);
        this.togglePreLoader(true);
        const res = await enrollProvider.postCoordinatorCourse({
          token: this.token,
          request: {
            classid_list: temp.map((t) => t.CLASSID),
            coordinator_hd_id: 0,
            acadyear: this.selYear,
            semester: this.selSemester,
            levelid: this.selLvl,
            facultyid: this.selected.FACULTYID,
            coursegroup: this.selected.COURSEGROUP,
            coursegroupdes: this.selected.COURSEDES,
            userid: this.mfuUserId,
            lang: this.currentLang,
          },
        });
        this.togglePreLoader(false);
        if (res.status == 200) {
          this.dialogConfirmSuccess = true;
          this.successText = `${res.message}<br/>`;
          this.getReqConfirmDetail();
        } else {
          this.dialogErrorTitle = "";
          this.dialogError = true;
          this.errorText = `${res.message}<br/>`;
        }
      }
      this.bTableProgram.items = [];
      this.classCodeList = [];
      this.dialogSelectClassCode = false;
      this.togglePreLoader(false);
    },
    async handleSelClsCodeIncrease(isClose) {
      const temp = this.bTableProgram.items.filter((i) => i.action);
      console.log("temp handleSelClsCodeIncrease", temp);
      this.togglePreLoader(true);
      if (!isClose) {
        // const temp = this.bTableProgram.items.filter((i) => {
        //   const found = this.classCodeList.filter((p) => p == i.CLASSID);
        //   return found.length > 0;
        // });
        const temp = this.bTableProgram.items.filter((i) => i.action);

        const res = await enrollProvider.postCoordinatorCourse({
          token: this.token,
          request: {
            classid_list: temp.map((t) => t.CLASSID),
            coordinator_hd_id: 0,
            acadyear: this.selYearIncrease,
            semester: this.selSemesterIncrease,
            levelid: this.selLvlIncrease,
            facultyid: this.selFacultyIncrease,
            coursegroup: this.selCoursegroup,
            coursegroupdes: this.desClassCodeGroup,
            userid: this.mfuUserId,
            lang: this.currentLang,
          },
        });

        if (res.status == 200) {
          this.dialogConfirmSuccess = true;
          this.successText = `${res.message}<br/>`;
          this.goTo(-1, -1, "edit");
          this.classCodeList = [];
          this.dialogSelectClassCodeIncrease = false;
          const result = await enrollProvider.getCoordinatorcourse({
            token: this.token,
            request: {
              acadyear: this.selYearIncrease,
              semester: this.selSemesterIncrease,
              levelid: this.selLvlIncrease,
              lang: this.currentLang,
            },
          });
        } else {
          this.dialogErrorTitle = "";
          this.dialogError = true;
          this.errorText = `${res.message}<br/>`;
        }
      }
      this.bTableProgram.items = [];

      this.togglePreLoader(false);
    },
    async handleCourseSearch() {
      this.togglePreLoader(true);
      const result = await enrollProvider.getCourse({
        token: this.token,
        request: {
          acadyear: this.selYear,
          semester: this.selSemester,
          levelid: this.selLvl,
          facultyid: this.selected.FACULTYID,
          coursegroup: this.selected.COURSEGROUP,
          coursecode:this.dlgCourseCode,
          coursename:this.dlgCourseName,
          lang: this.currentLang,
        },
      });
      this.bTableProgram.items = [];
      if (result.length > 0) {
        let idx = 0;
        const temp = result.map((d, idx) => {
          return {
            ...d,
            rowNumber: idx + 1,
            action: false,
          };
        });
        this.bTableProgram.items = temp;
      }
      this.togglePreLoader(false);
    },
    async handleCourseSearchIncrease() {
      this.togglePreLoader(true);
      const result = await enrollProvider.getCourse({
        token: this.token,
        request: {
          acadyear: this.selYearIncrease,
          semester: this.selSemesterIncrease,
          levelid: this.selLvlIncrease,
          facultyid: this.selFacultyIncrease,
          coursegroup: this.selCoursegroup,
          coursecode: this.dlgCourseCodeIncrease,
          coursename: this.dlgCourseNameIncrease,
          lang: this.currentLang,
        },
      });
      this.bTableProgram.items = [];
      if (result.length > 0) {
        let idx = 0;
        const temp = result.map((d, idx) => {
          return {
            ...d,
            rowNumber: idx + 1,
            action: false,
          };
        });
        this.bTableProgram.items = temp;
      }
      this.togglePreLoader(false);
    },
  },
  watch: {
    selTab(newVal, oldVal) {
      if (newVal == "tab-1") {
        this.deleteDataTxt = this.$t("messages.general.delCourseData");
      } else {
        this.deleteDataTxt = this.$t("messages.general.delPersonal");
      }
    },
    currentLang() {
      this.bTableProgram.fields = [
        {
          key: "action",
          label: "",
          thClass: "align-middle",
          thStyle: "width: 50px",
          sortable: true,
        },
        {
          key: "rowNumber",
          label: this.$t("messages.general.seqOrder"),
          thClass: "align-middle",
          thStyle: "width: 50px",
          sortable: true,
        },
        {
          key: "COURSECODE",
          label: this.$t("messages.general.classId"),
          thClass: "align-middle",
          thStyle: "width: 100px",
          sortable: true,
        },
        {
          key: "COURSENAME",
          label: this.$t("messages.general.className"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp col-250",
          sortable: true,
        },
        {
          key: "FACULTYNAME",
          label: this.$t("messages.general.faculty"),
          thClass: "align-middle",
          tdClass: "text-center text-nowarp col-150",
          sortable: true,
        },
        {
          key: "DEPARTMENTNAME",
          label: this.$t("messages.general.department"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp  col-150",
          sortable: true,
        },
        {
          key: "COURSEUNIT",
          label: this.$t("messages.general.credit"),
          thClass: "align-middle",
          thStyle: "width: 100px",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
      ];
      this.bTable.fields = [
        {
          key: "action",
          label: "",
          thClass: "align-middle",
          sortable: true,
        },
        {
          key: "rowNumber",
          label: this.$t("messages.general.seqOrder"),
          thClass: "align-middle",
          thStyle: "width: 50px",
          sortable: true,
        },
        {
          key: "ACADYEAR",
          label: this.$t("messages.general.academicYear"),
          thClass: "align-middle",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "SEMESTER",
          label: this.$t("messages.general.semester"),
          thClass: "align-middle",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "LEVELNAME",
          label: this.$t("messages.general.educationLvl"),
          thClass: "align-middle",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "FACULTYNAME",
          label: this.$t("messages.general.faculty"),
          thClass: "align-middle",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "COURSEDES",
          label: this.$t("messages.general.classCodeGroup"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
      ];
      this.bTableSelectClassCode.fields = [
        {
          key: "rowNumber",
          label: this.$t("messages.general.seqOrder"),
          thClass: "align-middle",
          thStyle: "width: 50px",
          sortable: true,
        },
        {
          key: "COURSECODE",
          label: this.$t("messages.general.classId"),
          thClass: "align-middle",
          thStyle: "width: 120px",
          sortable: true,
        },
        {
          key: "COURSENAME",
          label: this.$t("messages.general.className"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
        {
          key: "FACULTY",
          label: this.$t("messages.general.faculty"),
          thClass: "align-middle",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "action",
          label: "",
          thClass: "align-middle",
          sortable: true,
        },
      ];
      this.bTableSelectPersonnel.fields = [
        {
          key: "rowNumber",
          label: this.$t("messages.general.seqOrder"),
          thClass: "align-middle",
          sortable: true,
        },
        {
          key: "OFFICERCODE",
          label: this.$t("messages.general.identity"),
          thClass: "align-middle",
          sortable: true,
        },
        {
          key: "OFFICERNAME",
          label: this.$t("messages.general.fullname"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
        {
          key: "FACULTYNAME",
          label: this.$t("messages.general.underFac"),
          thClass: "align-middle",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "GENDER",
          label: this.$t("messages.general.gender"),
          thClass: "align-middle",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "actionSelpersonel",
          label: "",
          thClass: "align-middle",
          thStyle: "width: 50px",
          sortable: true,
        },
      ];
      this.bTablePersonnel.fields = [
        {
          key: "action",
          label: "",
          thClass: "align-middle",
          thStyle: "width: 50px",
          sortable: true,
        },
        {
          key: "rowNumber",
          label: this.$t("messages.general.seqOrder"),
          thClass: "align-middle",
          thStyle: "width: 50px",
          sortable: true,
        },
        {
          key: "OFFICERCODE",
          label: this.$t("messages.general.identity"),
          thClass: "align-middle",
          thStyle: "width: 120px",
          sortable: true,
        },
        {
          key: "NAME",
          label: this.$t("messages.general.fullname"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
        {
          key: "FACULTYNAME",
          label: this.$t("messages.general.underFac"),
          thClass: "align-middle",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "GENDER",
          label: this.$t("messages.general.gender"),
          thClass: "align-middle",
          thStyle: "width: 100px",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
      ];
      if (this.searched) {
        this.handleSearchConfirmResult();
      }
      this.getReqConfirmDetail();
      this.selectedCourseGroupOpts = [
        { text: this.$t("messages.general.notSpecified"), value: 0 },
        { text: "1", value: 1 },
        { text: "2", value: 2 },
        { text: "3", value: 3 },
        { text: "4", value: 4 },
        { text: "5", value: 5 },
        { text: "6", value: 6 },
        { text: "7", value: 7 },
        { text: "8", value: 8 },
        { text: "9", value: 9 },
        { text: "10", value: 10 },
        { text: "11", value: 11 },
        { text: "12", value: 12 },
        { text: "13", value: 13 },
        { text: "14", value: 14 },
        { text: "15", value: 15 },
        { text: "16", value: 16 },
        { text: "17", value: 17 },
        { text: "18", value: 18 },
        { text: "19", value: 19 },
        { text: "20", value: 20 },
        { text: "21", value: 21 },
        { text: "22", value: 22 },
        { text: "23", value: 23 },
        { text: "24", value: 24 },
        { text: "25", value: 25 },
        { text: "26", value: 26 },
        { text: "27", value: 27 },
        { text: "28", value: 28 },
        { text: "29", value: 29 },
        { text: "30", value: 30 },
      ];
    },
  },
};
</script>
